import React, { useEffect, useRef, useState } from "react";
import "./AdminArticle.css";
import { useNavigate } from "react-router-dom";
// import CustomCKEditor from "../CKEditor/CKEditor"
import ArticleForm from "./ArticleForm";
import {
  DeleteArticleDetail,
  PaginatedArticle,
  SetVisibilityArticle,
} from "../../api/ArticleApi/Article";
import { toast } from "react-toastify";
import Pagination from "../../app/components/Pagination/Pagination";
import { CommonStatus } from "../../app/Enums/StatusEnums";
import { blogVisibilityStatus } from "../../app/Enums/StatusEnums";
import { RoleId } from "../../app/Enums/RoleId";
import { routePath } from "../../app/routes/routepath";
import LoadingSpinner from "../../app/components/Loader/LoadingSpinner";
import addSvg from "../../assets/icons/add.svg";
import viewSvg from "../../assets/icons/view.svg";
import binSvg from "../../assets/icons/bin.svg";
import editSvg from "../../assets/icons/edit.svg";
import DeleteModal from "../../app/components/FeedbackModal/DeleteModal/DeleteModal";
import { Ban, CheckCircle, Eye, Lock, SquarePen, ToggleLeft, ToggleRight, Trash2, Unlock } from "lucide-react";
function AdminArticle() {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [Value, setValue] = useState({
    StatusId: 0, 
    PageNo: 1,
    PageSize: 10,
    authorId: 0,
    RoleId: 0,
  });
  const [showList, setshowList] = useState(true);
  const [ReceivedDbData, setReceivedDbData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const totalPages = Math.ceil(totalRows / Value.PageSize);
  const [switchButton, setswitchButton] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const tableRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  // we use two useEffects for get article because
  //  if we put all in one useEffect, then it cause issue in rendering article . 
   useEffect(() => {
    if(switchButton === true){
    GetArticles();
    setswitchButton(false);
    }
  }, [ switchButton]);

 

  async function GetArticles() {
    try {
      var response = await PaginatedArticle(Value);
      if (response.result == 1) {
        setIsLoading(false);
        setTotalRows(response.totalRows);
        setReceivedDbData(response.result_value);
        
      }
      
    } catch (err) {
      console.log(err);
    }
  }

  const UserId = localStorage.getItem("UserId");
  const roleId = Number(localStorage.getItem("RoleId"));

  useEffect(() => {
    var setStatusAsPerRole = 0;
    if (roleId === RoleId.SuperAdmin) {
      setStatusAsPerRole = 0; // All statuses
    } else if (roleId === RoleId.Admin) {
      setStatusAsPerRole = CommonStatus.Approved; // Approved articles only
    }
    setValue((pre) => ({
      ...pre,
      authorId: UserId,
      RoleId: roleId,
      StatusId: setStatusAsPerRole,
    }));
  }, []);


   useEffect(() => {
    if(Value.RoleId!= 0 &&  Value.authorId != 0){
    GetArticles();
    }
  }, [Value]);

  const openModalBox = () => {
    navigate(routePath.ArticleForm);
  };

  const navigateDashboard = () => {
    navigate(routePath.dashboard);
  };

  // const ViewArticle = (ArticleData) => {
  //   navigate(routePath.ViewArticle, { state: ArticleData });
  // };

  const EditArticle = (EditArticle) => {
    navigate(routePath.editArticle, { state: EditArticle });
  };

  const DeleteArticle = (EditArticle) => {
    var articleID = EditArticle.articleId;

    try {
      var response = DeleteArticleDetail({ articleID });
      if ((response.result = 1)) {
        toast.success("Success: Article Deleted");
        setShowDeleteModal(false);
        GetArticles();
      } else {
        toast.error("Failed");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const selectedValue = Number(e.target.value); // convert string to number
    setValue((prev) => ({
      ...prev, // keep PageNo, PageSize
      StatusId: selectedValue,
    }));
  };

  const handleDisable = async (result) => {
    try {
      const data = {
        isActive: blogVisibilityStatus.disable,
        articleId: result.articleId,
      };
      var response = await SetVisibilityArticle(data);
      if (response.result == 1) {
        toast.success("visibility changed");

        setswitchButton(true);
      }
    } catch (err) {}
  };

  const handleEnable = async (result) => {
    try {
      const data = {
        isActive: blogVisibilityStatus.enable,
        articleId: result.articleId,
      };
      var response = await SetVisibilityArticle(data);
      if (response.result == 1) {
        toast.success("visibility changed");
        setswitchButton(true);
      }
    } catch (err) {}
  };
  const handleView = (articleId) => {
    navigate(routePath.ViewArticle, {
      state: {
        articleId: articleId,
        returnPath: "/adminArticle",
      },
    });
  };

  useEffect(() => {
    tableRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [Value]);

  const openModalSeMore = (description) => {
    setSelectedDescription(description);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDescription("");
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-out-wraper">
          <div className="role-box">
            <h2 className={roleId === RoleId.Admin ? "" : "mb-0"}>Admin Article</h2>
            <div className="search-filter-section">
              {/* {roleId === RoleId.SuperAdmin && (
                <span>All Admins Approved Articles shows here!</span>
              )} */}
              {roleId === RoleId.Admin ? (
                <div className="form-wraper">
                  <label>Select Option</label>
                  <select
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  >
                    {/* <option value={0}>All</option> */}
                    <option value={CommonStatus.Approved}>Approved</option>
                    <option value={CommonStatus.Archived}>Draft</option>
                  </select>
                </div>
              ) : null}

              {roleId === RoleId.Admin && (
                <div>
                  <button
                    type="button"
                    className="primary_btn"
                    onClick={openModalBox}
                  >
                    <img src={addSvg} alt="Add" />
                    Add Article
                  </button>
                </div>
              )}
              <div></div>
            </div>
          </div>
          <div className="main_widget">
            {showList && (
              <>
                <div className="main_widget_body">
                  <div className="table-responsive" ref={tableRef}>
                    <table>
                      <thead>
                        <tr>
                          <th className="sn_th">S.No</th>
                          <th className="name_th">Title</th>
                          <th className="cover_th">Image</th>
                          <th className="des_th">Summary</th>
                          {Value.StatusId == 0 &&
                          roleId == RoleId.SuperAdmin ? (
                            <th>Author Name</th>
                          ) : null}
                          {/* {Value.StatusId == CommonStatus.Approved ||
                            (Value.StatusId == 0 &&
                              Value.RoleId == RoleId.SuperAdmin) ? (
                            <th className="action_th">Visibility</th>
                          ) : null} */}
                          {(Value.StatusId == CommonStatus.Approved &&
                            roleId == RoleId.Admin) ||
                            roleId == RoleId.SuperAdmin ? (
                              //  ||
                              //   Value.StatusId == 0
                              <th className="action_th">Status</th>
                            ) : null}
                            <th className="action_th">Action</th>
                          {/* {Value.StatusId == CommonStatus.Rejected && (
                            <th className="action_td">Action</th>
                          )} */}
                        </tr>
                      </thead>
                      <tbody>
                        {ReceivedDbData.map((result, index) => (
                          <tr key={index}>
                            <td>
                              {(Value?.PageNo - 1) * Value?.PageSize +
                                index +
                                1}
                            </td>
                            <td style={{wordBreak: "break-all"}}>{result.articleTitle}</td>
                            <td>
                              <div>
                                <img
                                  className="CoverImage"
                                  src={result.articleCoverImage}
                                />
                              </div>
                            </td>
                            <td>
                              {/* {result.articleDescription} */}
                              {result.articleDescription.length > 80 ? (
                                <>
                                  {result.articleDescription.slice(0, 80)}...
                                  <span
                                    className="see-more"
                                    onClick={() =>
                                      openModalSeMore(result.articleDescription)
                                    }
                                  >
                                    {" "}
                                    See more
                                  </span>
                                </>
                              ) : (
                                result.articleDescription
                              )}
                            </td>
                            {Value.StatusId == 0 ? (
                              <td>{result.authorName}</td>
                            ) : null}
                           

                            

                            {Value.StatusId === 0 &&
                              (Value.RoleId === RoleId.Admin ||
                                Value.RoleId === RoleId.SuperAdmin) && (
                                <td>
                                  {result.isActive === 1 ? (
                                    // <strong id="EnableVisibility">
                                    //   Active
                                    // </strong>
                                    <div id="EnableVisibility" className="tooltip-wrapper" style={{'--bg-color': '#16a34a'}}>
                                      <CheckCircle className="icon icon-active" />
                                      <span className="tooltip-text">Active</span>
                                    </div>
                                  ) : (
                                    // <strong id="DisableVisibility">
                                    //   InActive
                                    // </strong>
                                    <div id="DisableVisibility" className="tooltip-wrapper" style={{'--bg-color': '#9ca3af'}}>
                                      <Ban className="icon icon-inactive" />
                                      <span className="tooltip-text">Inactive</span>
                                    </div>
                                  )}
                                </td>
                              )}


                            {Value.StatusId === CommonStatus.Approved &&
                              Value.RoleId === RoleId.Admin && (
                                <td>
                                  {result.isActive === 1 ? (

                                    <div className="tooltip-wrapper" style={{'--bg-color': '#dc2626'}}
                                onClick={() =>
                                    handleDisable(result)
                                  }
                                >
                                      <Unlock className="icon icon-deactivated" />
                                      <span className="tooltip-text">Disable</span>
                                    </div>
                                  ) : (
                                    <div className="tooltip-wrapper" style={{'--bg-color': '#22c55e'}}
                                 onClick={() => handleEnable(result)}
                                >
                                      <Lock className="icon icon-approved" />
                                      <span className="tooltip-text">Enable</span>
                                    </div>
                                  )}
                                </td>
                              )}
                               <td>
                              <div className="d-flex align-items-center gap_10 justify-content-center">
                              <div className="tooltip-wrapper" style={{'--bg-color': '#002954'}}
                              onClick={() => handleView(result.articleId)}
                              >
                                <Eye className="icon icon-view" />
                                <span className="tooltip-text">View Article</span>
                              </div>
                              
                              {Value.StatusId == CommonStatus.Approved ||
                              Value.StatusId == CommonStatus.Archived ? (
                                <div className="tooltip-wrapper" style={{'--bg-color': '#F59E0B'}}
                              onClick={() => EditArticle(result)}
                              >
                                <SquarePen className="icon icon-btn" />
                                <span className="tooltip-text">Edit Article</span>
                              </div>
                               
                              ) : null}
                              {Value.StatusId == CommonStatus.Approved ||
                              Value.StatusId == CommonStatus.Archived ? (
                                
                                  <div className="tooltip-wrapper" style={{'--bg-color': '#dc2626'}}
                               onClick={() => {
                                    setSelectedArticle(result);
                                    setShowDeleteModal(true);
                                  }}
                              >
                                <Trash2 className="icon icon-deactivated" />
                                <span className="tooltip-text">Delete Article</span>
                              </div>
                              ) : null}
                              </div>
                            </td>
                          </tr>
                        ))}

                        {!isLoading && ReceivedDbData.length === 0 && (
                          <tr>
                            <td colSpan="7" style={{ textAlign: "center" }}>
                              No Article found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
          <Pagination
            currentPage={Value.PageNo}
            totalPages={totalPages}
            pageSize={Value.PageSize}
            onPageChange={(page) =>
              setValue((prev) => ({ ...prev, PageNo: page }))
            }
            onPageSizeChange={(size) =>
              setValue((prev) => ({ ...prev, PageSize: size, PageNo: 1 }))
            }
          />
        </div>
      )}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Summary</h2>
            <p>{selectedDescription}</p>
            <div className="d-flex justify-content-center">
              <button className="primary_btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

     <DeleteModal
        isOpen={showDeleteModal}
        onConfirm={() => {
          DeleteArticle(selectedArticle);
          
        }}
        onCancel={() => {
          setShowDeleteModal(false);
        }}
        title="Delete Article"
        message={`Are you sure you want to delete this article?`}
      />
    </>
  );
}

export default AdminArticle;
